import React, { memo, useEffect, useRef, } from 'react';
import { VerificationCardTypeTokens, } from '@voltmoney/schema';
import { VerificationCardBase } from './VerificationCard.base';
import VerificationAlertBase from './VerificationAlert.base';
import { VerificationDefaultBase } from './VerificationDef.base';
import VerificationProgressBase from './VerificationProgress.base';
import VerificationFailedBase from './VerificationFailed.base';
import VerificationWarningBase from './VerificationWarning.base';
const VerificationCard = ({ type = VerificationCardTypeTokens.Success, onPress, action, triggerAction, isAutoTriggerCta = false, autoTriggerTimerInMilliseconds = 1000, shouldAutoNavigate, ...props }) => {
    const refreshAction = action
        ? JSON.stringify(action)
        : '';
    const timerRef = useRef(null);
    useEffect(() => {
        if (isAutoTriggerCta &&
            action &&
            triggerAction) {
            timerRef.current = setTimeout(async () => {
                await triggerAction(action);
            }, autoTriggerTimerInMilliseconds);
        }
        return () => clearTimeout(timerRef.current);
    }, [refreshAction]);
    switch (type) {
        case VerificationCardTypeTokens.Alert:
            return (React.createElement(VerificationAlertBase, { type: type, ...props, onPress: onPress, action: action, triggerAction: triggerAction }));
        case VerificationCardTypeTokens.Default:
            return (React.createElement(VerificationDefaultBase, { type: type, ...props, onPress: onPress, action: action, triggerAction: triggerAction }));
        case VerificationCardTypeTokens.Success:
            return (React.createElement(VerificationCardBase, { type: type, ...props, onPress: onPress, action: action, triggerAction: triggerAction, shouldAutoNavigate: shouldAutoNavigate }));
        case VerificationCardTypeTokens.InProgress:
            return (React.createElement(VerificationProgressBase, { type: type, ...props, onPress: onPress, action: action, triggerAction: triggerAction }));
        case VerificationCardTypeTokens.Failed:
            return (React.createElement(VerificationFailedBase, { type: type, ...props, onPress: onPress, action: action, triggerAction: triggerAction }));
        case VerificationCardTypeTokens.Warning:
            return (React.createElement(VerificationWarningBase, { type: type, ...props, onPress: onPress, action: action, triggerAction: triggerAction }));
        default:
            return React.createElement(React.Fragment, null);
    }
};
export default memo(VerificationCard);
export { VerificationCard };
